export function storeAdminImpl(
  data: any,
  setJWT: (token: string) => void,
  setServerVersion: (token: number) => void,
  setInvoicesExpired: (token: number) => void,
  setPendingAuth: (token: number) => void,
  setPendingGuests: (token: number) => void,
  setGuests: (token: number) => void,
  setNotifications: (token: number) => void,
  setShowPropertiesSelector: (token: number) => void,
  setMenu?: (token: any) => void,
  setGData?: (token: any) => void
) {

  if (data && data.JWTRenew ) {
    //console.log("setJWTRenew:" + data.JWTRenew)
    setJWT(data.JWTRenew);
    //localStorage.setItem("JWT", data.token);
  }
  if (data.JWT===false) {
    //console.log("JWT:" + data.JWT)
    setJWT("");
    //setGData(data.admin)
  }
  if (data && data.admin && data.admin.properties) {
    setShowPropertiesSelector(data.admin.properties.length)
  }
  if (data && data.admin && data.admin.counters) {
    setInvoicesExpired(data.admin.counters.invoicesExpired)
    setPendingAuth(data.admin.counters.pendingAuth)
    setPendingGuests(data.admin.counters.pendingGuests)
    setGuests(data.admin.counters.guests)
    setNotifications(data.admin.counters.notifications)
    console.log(data.admin.counters.notifications)
  }

  if (data && data?.serverVersion) {
    setServerVersion(data.serverVersion)
  }
  if (data && data.admin && data.admin.menu && typeof setMenu === 'function') {
    setMenu(data.admin.menu);
  }
  if (data && data.admin && typeof setGData === 'function') {
    setGData(data.admin)
  }


  if (data?.serverVersion) {
    setServerVersion(data.serverVersion);
    //localStorage.setItem("serverVersion", data.serverVersion.toString());
  }

}
